module.exports = __webpack_public_path__ + "static/img/YB-13VN.c5a4a11a.png";